import {
  TooltipContent,
  TooltipSection,
  TooltipTitle,
  TooltipOperator,
  TooltipExample,
  TooltipSeparator,
  TooltipExamplesTitle,
} from './BooleanTooltip.styles'

type Props = {
  /**
   * Liga a explicação de casamento por palavra inteira. Só vale onde o texto é
   * avaliado pelo matcher de termos de marca do ETL (`read_bool_string.py`).
   * Nas outras telas que usam este tooltip as aspas não têm esse efeito: em
   * temas elas são descartadas antes do casamento, e no filtro de menções elas
   * entram literalmente no ILIKE.
   */
  exactQuotes?: boolean
}

export function BooleanTooltipContent({ exactQuotes = false }: Props) {
  return (
    <TooltipContent>
      <TooltipTitle>Use operadores booleanos para filtrar:</TooltipTitle>
      <TooltipSection>
        <TooltipOperator>AND, OR ou NOT</TooltipOperator>
      </TooltipSection>
      <TooltipSeparator />
      <TooltipExamplesTitle>Exemplos:</TooltipExamplesTitle>
      <TooltipSection>
        • <TooltipExample>produto AND marca</TooltipExample>
      </TooltipSection>
      <TooltipSection>
        • <TooltipExample>tecnologia OR inovação</TooltipExample>
      </TooltipSection>
      <TooltipSection>
        • <TooltipExample>desempenho AND NOT falha</TooltipExample>
      </TooltipSection>
      <TooltipSection>
        • <TooltipExample>&quot;atendimento ao cliente&quot; AND ruim</TooltipExample>
      </TooltipSection>
      <TooltipSection>Use aspas para buscar a frase exata, e não cada palavra separada.</TooltipSection>
      {exactQuotes && (
        <TooltipSection>
          Entre aspas, o termo só casa como palavra inteira: <TooltipExample>&quot;Icó&quot;</TooltipExample> não pega
          dentro de &quot;público&quot;. Sem aspas, casa em qualquer parte da palavra.
        </TooltipSection>
      )}
    </TooltipContent>
  )
}

export * from './BooleanTooltip.styles'
